import updateShop from '../../../../actions/siteadmin/ManageShop/updateShop';

async function submit(values, dispatch) {

    await dispatch(
        updateShop(values)
    )
}

export default submit;